// extracted by mini-css-extract-plugin
module.exports = {"appfooter":"AppFooter_appfooter__qPLkg"};